import React from 'react';
import Layout from '../../../components/Layout';
import ServicesLayout from '../../../components/ServicesLayout';
import Claims from './Claims';
const title = 'Zarządzanie Urzędami';

import { isAdminUser } from '../../../lib/utils';

export default {

  path: '/claims',
  async action(ctx) {
    const isAdmin = await isAdminUser(ctx);
    if (!isAdmin) {
      return { redirect: '/' };
    }
    return {
      title,
      chunk: 'districts',
      component: <ServicesLayout isAdmin><Claims /></ServicesLayout>,
    };
  },
};


// WEBPACK FOOTER //
// src/routes/admin/claims/index.js